// Stok Ayrıntıları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.itemDetail';

export const inventoryItemDetailGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Stok Ayrıntıları nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu pencere bir ürünün stok kartını tek sayfada gösterir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Kart bilgileri'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere yalnız görüntüleme içindir'),
      text: t(`${G}.s1.text`, 'Burada değişiklik yapılmaz. Ürün bilgilerini değiştirmek için stok listesinde satırın ⋮ menüsünden "Düzenle"yi kullanın. Başlığın altındaki ID, ürünün sistemdeki kimlik numarasıdır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Temel Bilgiler'),
      text: t(`${G}.s2.text`, 'En üstte ürün adı ve Aktif / Pasif durumu görünür. Temel Bilgiler bölümünde Stok Kodu, Barkod, Kategori, Marka, ürünün stoğu bulunan depolar ve Oluşturulma Tarihi yer alır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Miktar ve Fiyat Bilgileri'),
      text: t(`${G}.s3.text`, 'Stok Miktarı, ürünün tüm depolardaki stoklarının toplamıdır. Alış, Satış ve Liste Fiyatı para birimiyle birlikte gösterilir; "Stok Eksiye Düşebilir" stok bitse de satışa izin verilip verilmediğini söyler.'),
      tips: [
        t(`${G}.s3.tip1`, 'Üretim modülü açıksa Ürün Sınıfı (Hammadde, Yarı Mamul, Mamul, Ambalaj, Yan Ürün, Ticari Mal) ve Üretim Şekli (Stoklu / Satışta) de görünür.'),
        t(`${G}.s3.tip2`, 'Ürün akıllı (WMS) depo raflarında duruyorsa "Lokasyon Dağılımı" tablosu hangi lokasyonda ne kadar olduğunu gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Vergi, departman ve açıklama'),
      text: t(`${G}.s4.text`, 'Vergi Bilgileri bölümünde KDV Oranı, KDV Durumu (Dahil / Hariç) ve varsa ÖTV oranı ile durumu yer alır. Departman No (ÖKC), ürünün yazar kasada satıldığı departmandır. Açıklama bölümü ürün notunu gösterir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Varyant özellikleri ve resimler'),
      text: t(`${G}.s5.text`, 'Ürüne renk, beden, malzeme, paket gibi özellikler girildiyse "Varyant Özellikleri (Salt Okunur)" bölümünde listelenir. "Ürün Resimleri" bölümünde bir resmin üzerine gelip göz simgesine tıklayarak büyük halini açın.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Pencereyi kapatın'),
      text: t(`${G}.s6.text`, '"Kapat" ile listeye dönün. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
